import apiClient from "./client";

export const storeRequestApi = {
  getDraft: async () => {
    const response = await apiClient.get("/store-requests/draft");
    return response.data;
  },

  saveDraft: async (data) => {
    const response = await apiClient.put("/store-requests/draft", { data });
    return response.data;
  },

  deleteDraft: async () => {
    const response = await apiClient.delete("/store-requests/draft");
    return response.data;
  },

  getEditDraft: async (id) => {
    const response = await apiClient.get(`/store-requests/${id}/draft`);
    return response.data;
  },

  saveEditDraft: async (id, data) => {
    const response = await apiClient.put(`/store-requests/${id}/draft`, { data });
    return response.data;
  },

  deleteEditDraft: async (id) => {
    const response = await apiClient.delete(`/store-requests/${id}/draft`);
    return response.data;
  },

  createRequest: async (data) => {
    const response = await apiClient.post("/store-requests", data);
    return response.data;
  },

  updateRequest: async (id, data) => {
    const response = await apiClient.put(`/store-requests/${id}`, data);
    return response.data;
  },

  getClientRequests: async () => {
    const response = await apiClient.get("/store-requests");
    return response.data;
  },

  getRequestById: async (id) => {
    const response = await apiClient.get(`/store-requests/${id}`);
    return response.data;
  },

  getAllRequests: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const response = await apiClient.get(`/store-requests/admin/all?${params}`);
    return response.data;
  },

  updateStatus: async (id, status, notes = null) => {
    const response = await apiClient.put(`/store-requests/admin/${id}/status`, {
      status,
      notes,
    });
    return response.data;
  },

  updateEditingAccess: async (id, unlocked) => {
    const response = await apiClient.put(
      `/store-requests/admin/${id}/edit-access`,
      { unlocked },
    );
    return response.data;
  },

  deleteRequest: async (id) => {
    const response = await apiClient.delete(`/store-requests/admin/${id}`);
    return response.data;
  },

  getStats: async () => {
    const response = await apiClient.get("/store-requests/admin/stats");
    return response.data;
  },
};
